export default __webpack_public_path__ + "static/media/manonmoonsmall.2ae16916.png";